/* unplugin-vue-components disabled */import script from "./TransitionRouteView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransitionRouteView.vue?vue&type=script&lang=ts&setup=true"

import "./TransitionRouteView.vue?vue&type=style&index=0&id=8085378e&lang=less"

const __exports__ = script;

export default __exports__